<template>
  <div>
    <div class="wz-page-header">
      <h1 class="wz-page-title">Liquidaciones</h1>
    </div>

    <wz-table-container>
      <wz-table-toolbar>
        <template #left>
          <div style="min-width: 320px; flex-shrink: 0">
            <wz-select
              label="Empresa"
              v-model="companyId"
              :items="companies"
              defaultOption="Seleccione una empresa"
              @change="loadData"
            />
          </div>
          <div style="min-width: 160px; flex-shrink: 0">
            <wz-select
              label="Estado"
              v-model="statusFilter"
              :items="statusOptions"
              defaultOption="Todos"
            />
          </div>
          <div style="min-width: 220px; flex-shrink: 0">
            <wz-input label="Buscar" v-model="search" placeholder="Nombre o DNI" />
          </div>
        </template>

        <template #right>
          <wz-tooltip text="Recargar">
            <wz-button variant="outline" @click="loadData()">
              <i class="ri-loop-right-line"></i>
            </wz-button>
          </wz-tooltip>
          <wz-button variant="primary" @click="$router.push({ name: 'severance-calculate' })">
            <i class="ri-file-add-line mr-1"></i>Nueva liquidación
          </wz-button>
        </template>
      </wz-table-toolbar>

      <wz-table>
        <thead>
          <tr>
            <th>Colaborador</th>
            <th>DNI</th>
            <th>Motivo de cese</th>
            <th>Fecha de cese</th>
            <th class="text-right">Total bruto</th>
            <th class="text-right">Total neto</th>
            <th class="text-center">Estado</th>
            <th>Fecha de pago</th>
            <th class="text-center">Opciones</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="o in filteredList" :key="o.id">
            <td>{{ o.employeeFullName || '-' }}</td>
            <td>{{ o.employeeDni || '-' }}</td>
            <td>{{ o.cessationReasonName || '-' }}</td>
            <td v-local-date="o.terminationDate"></td>
            <td class="text-right">
              <span v-decimal:pen="o.totalGross" v-if="o.totalGross != null"></span>
              <span v-else>-</span>
            </td>
            <td class="text-right">
              <span v-decimal:pen="o.totalNet" v-if="o.totalNet != null"></span>
              <span v-else>-</span>
            </td>
            <td class="text-center">
              <wz-badge :variant="statusVariant(o.status)" pill>{{ statusLabel(o.status) }}</wz-badge>
            </td>
            <td v-local-date="o.paymentDate"></td>
            <td class="text-center">
              <wz-button variant="outline" size="sm"
                @click="$router.push({ name: 'severance-detail', params: { id: o.id } })">
                Ver detalle
              </wz-button>
            </td>
          </tr>
        </tbody>
      </wz-table>

      <wz-table-footer>
        <div class="table-no-results" v-if="!filteredList.length">
          <p class="m-0 px-3">
            {{ companyId ? 'No se encontraron liquidaciones.' : 'Seleccione una empresa para ver las liquidaciones.' }}
          </p>
        </div>
      </wz-table-footer>
    </wz-table-container>
  </div>
</template>

<script>
import { Alert } from '@wizepe/wizeui'
import { SeveranceService, CompanyService } from '@/core/services'

const STATUS_META = {
  BORRADOR:   { label: 'Borrador',   variant: 'warning-solid' },
  CONFIRMADO: { label: 'Confirmado', variant: 'info-solid' },
  PAGADO:     { label: 'Pagado',     variant: 'success-solid' },
  ANULADO:    { label: 'Anulado',    variant: 'danger-solid' },
}

export default {
  data() {
    return {
      companyId: null,
      companies: [],
      statusFilter: null,
      statusOptions: Object.keys(STATUS_META).map(k => ({ key: k, label: STATUS_META[k].label })),
      search: '',
      list: [],
    }
  },
  computed: {
    filteredList() {
      const q = (this.search || '').trim().toLowerCase()
      return this.list.filter(o => {
        if (this.statusFilter && o.status !== this.statusFilter) return false
        if (q) {
          const hay = `${o.employeeFullName || ''} ${o.employeeDni || ''}`.toLowerCase()
          if (!hay.includes(q)) return false
        }
        return true
      })
    },
  },
  methods: {
    statusLabel(status) {
      const s = STATUS_META[status]
      return s ? s.label : status
    },
    statusVariant(status) {
      const s = STATUS_META[status]
      return s ? s.variant : 'dark'
    },
    async loadData() {
      if (!this.companyId) { this.list = []; return }
      try {
        this.$store.dispatch('app/loading', true)
        const resp = await SeveranceService.getSettlements(this.companyId)
        this.list = resp.payload || []
      } catch (e) {
        console.error(e)
        Alert.error(e.errors ? e.errors.message : 'Error al cargar las liquidaciones')
      } finally {
        this.$store.dispatch('app/loading', false)
      }
    },
    async loadCompanies() {
      try {
        const resp = await CompanyService.listAll()
        this.companies = (resp.payload || []).map(c => ({ key: c.id, label: c.name }))
      } catch (e) {
        console.error(e)
      }
    },
  },
  async created() {
    await this.loadCompanies()
    // Al volver del wizard se recibe companyId para preseleccionar y refrescar la lista
    // (así aparece el borrador recién generado sin re-seleccionar la empresa).
    const queryCompanyId = this.$route.query.companyId
    if (queryCompanyId) {
      this.companyId = Number(queryCompanyId)
      await this.loadData()
    }
  },
}
</script>
